import { z } from "zod";
import { Color } from "../shared/colors";
import { BaseOverlayConfig } from "../shared/config";
import { defineOverlay } from "../shared/functions";
const types = ["classic", "rounded", "slanted"];
const timerOptions = [
    "ALWAYS",
    "FIFTEEN_MINUTES",
    "FIVE_MINUTES",
    "TEN_MINUTES",
];
const backgroundColors = [
    Color.DEFAULT_RED,
    Color.LIGHT_PURPLE,
    Color.DARK_PURPLE,
    Color.LIGHT_BLUE,
    Color.DARK_BLUE,
    Color.LIGHT_AQUA,
    Color.LIGHT_GREEN,
    Color.DARK_GREEN,
    Color.LIGHT_YELLOW,
    Color.DARK_YELLOW,
];
export const RewardsOverlay = defineOverlay({
    defaults: {
        backgroundColor: Color.DEFAULT_RED,
        demoMode: false,
        highlightFeaturedRewards: true,
        showAllRewards: true,
        showQuantityRemaining: true,
        timer: "ALWAYS",
        type: "slanted",
    },
    details: {
        category: "overlays",
        description: "Utilize our dynamic Rewards overlay to enhance your Tiltify fundraising campaign. Easily display your Tiltify Rewards on your stream without the need of creating a graphic",
        features: [
            "<b>Update: Will feature rewards that you have highlighted on Tiltify</b>",
            "Displays your Tiltify Rewards on stream",
            "Rotates in and out on a timer",
            "Automatically updates when new Rewards are added",
            "Customize colors to fit your stream",
        ],
        flags: {
            isFeatured: false,
            isNew: false,
            isUpdated: false,
            isVisible: true,
        },
        icon: "overlays/rewards.png",
        name: "Rewards Overlay",
        path: "/overlays/rewards",
        shortDescription: "Easily display your Tiltify Rewards on your stream without creating a graphic.",
        slug: "rewards",
    },
    schema: BaseOverlayConfig.extend({
        backgroundColor: z
            .enum(backgroundColors)
            .default(() => RewardsOverlay._config.defaults.backgroundColor)
            .optional(),
        highlightFeaturedRewards: z
            .boolean()
            .default(() => RewardsOverlay._config.defaults.highlightFeaturedRewards)
            .optional(),
        showAllRewards: z
            .boolean()
            .default(() => RewardsOverlay._config.defaults.showAllRewards)
            .optional(),
        showQuantityRemaining: z
            .boolean()
            .default(() => RewardsOverlay._config.defaults.showQuantityRemaining)
            .optional(),
        timer: z
            .enum(timerOptions)
            .default(() => RewardsOverlay._config.defaults.timer)
            .optional(),
        type: z
            .enum(types)
            .default(() => RewardsOverlay._config.defaults.type)
            .optional(),
    }),
});
//# sourceMappingURL=rewards.js.map